import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    MatIcon,
    MatButton
  ],
  selector: 'equine-ui-nx-success-landing',
  templateUrl: './success-landing.component.html',
  styleUrls: ['./success-landing.component.scss']
})
export class SuccessLandingComponent {
  constructor(
    private readonly router: Router
  ){}

  goToDashboard() {
    this.router.navigate(["dashboard"]).then(() => {
      window.location.reload();
    });
  }

}
